exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.article-wrapper {\n  padding: 0 0.53333333rem;\n}\n._title {\n  font-size: 0.53333333rem;\n  color: #333;\n  padding: 0.53333333rem 0;\n  line-height: 1.5em;\n}\n.article-desc {\n  border-bottom: 0.02666667rem solid #ccc;\n  padding-bottom: 0.4rem;\n  margin-bottom: 0.53333333rem;\n}\n.external_content {\n  /*margin:0 20px;*/\n  padding-bottom: 2.66666667rem;\n  line-height: 1.7em;\n}\n.external_content img {\n  max-width: 100%;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7f59f181!./~/autoprefixer-loader!./~/px2rem-loader?remUnit=37.5&remPrecision=8!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/article-detail.vue
// module id = 239
// module chunks = 1